// Click event handling
// Keyboard event handling
// hover handling to show navigation
import { showNavigation, tracker } from "../app-signals.js";
import {
	goToNext,
	goToPrevious,
	goToPage,
	goToStart,
	goToEnd,
} from "../page-signals.js";

export function setupEvents(root = document.documentElement) {
	document.documentElement.addEventListener("keydown", handleKeyboard);
	root.addEventListener("click", handleClick);
	root.addEventListener("mousemove", handleMouseMove);
}
const overlayPercentage = 0.15;

function leftRightMiddle(x, width) {
	if (x / width < overlayPercentage) {
		return "left";
	} else if (x / width > 1 - overlayPercentage) {
		return "right";
	} else {
		return "middle";
	}
}

// Need to test this one manually.
export function handleMouseMove(event) {
	const x = event.clientX;
	const width = window.innerWidth;
	const position = leftRightMiddle(x, width);
	if (position === "left") {
		event.currentTarget.classList.add("left-hover");
		event.currentTarget.classList.remove("right-hover");
	} else if (position === "right") {
		event.currentTarget.classList.add("right-hover");
		event.currentTarget.classList.remove("left-hover");
	} else {
		event.currentTarget.classList.remove("right-hover");
		event.currentTarget.classList.remove("left-hover");
	}
}

export function handleClick(event) {
	const anchor = event.target.closest("a[href]");
	const button = event.target.closest("button");
	const trackerService = tracker();
	if (trackerService && (anchor || button)) {
		trackerService.handleEvents(event.target, false);
	}
	const topBar = event.target.closest(".top-bar");
	if (!anchor && !button && !topBar) {
		event.preventDefault();
		event.stopPropagation();
		const x = event.clientX;
		const width = window.innerWidth;
		if (x / width < overlayPercentage) {
			goToPrevious();
		} else if (x / width > 1 - overlayPercentage) {
			goToNext();
		} else {
			showNavigation(!showNavigation());
		}
	} else if (anchor) {
		const href = anchor.getAttribute("href");
		if (anchor.rel === "next" || anchor.rel === "prev") {
			// The bottom-bar arrows: their #page= hrefs are only a fallback,
			// and in spread mode page + 1 is still on screen.
			event.preventDefault();
			event.stopPropagation();
			if (anchor.rel === "next") {
				goToNext();
			} else {
				goToPrevious();
			}
		} else if (href.startsWith("#")) {
			event.preventDefault();
			event.stopPropagation();
			const params = new URLSearchParams(href.slice(1));
			if (params.get("page")) {
				goToPage(Number.parseInt(params.get("page"), 10));
			}
		}
	}
}

export function handleKeyboard(event) {
	switch (event.key) {
		case "ArrowLeft":
			event.preventDefault();
			event.stopPropagation();
			goToPrevious();
			break;
		case "ArrowRight":
			event.preventDefault();
			event.stopPropagation();
			goToNext();
			break;
		case "Home":
			event.preventDefault();
			event.stopPropagation();
			goToStart();
			break;
		case "End":
			event.preventDefault();
			event.stopPropagation();
			goToEnd();
			break;
	}
}
